<div class="form-2-container">
  @if (simulatorForm) {
    <form [formGroup]="simulatorForm" (ngSubmit)="simulate.emit()">
      <div class="d-flex flex-column flex-lg-row align-items-center mb-3 type-selector-container">
        <div
          class="type-selector product-campaign-selector"
          [class.active]="simulatorForm?.value?.projectType == TimelineCampaignTypes.PRODUCT_CAMPAIGN"
          (click)="switchProjectType(TimelineCampaignTypes.PRODUCT_CAMPAIGN)"
          role="button">
          <span class="text-uppercase project-type-title">{{ 'productCampaign' | translate }}</span>
        </div>
        <div class="py-2 px-lg-4 separator">
          <span class="separator-title"> or </span>
        </div>
        <div
          class="type-selector hallmark-selector"
          [class.active]="simulatorForm?.value?.projectType == TimelineCampaignTypes.HALLMARKS"
          (click)="switchProjectType(TimelineCampaignTypes.HALLMARKS)"
          role="button">
          <span class="text-uppercase project-type-title">{{ 'hallmarks' | translate }}</span>
        </div>
      </div>

      <div class="fields-container">
        <div class="form-group">
          <label for="expectedMad">
            <span class="icon-wrapper"><i class="fa fa-question" aria-hidden="true"></i></span>
            <span class="text">{{ 'timelineSimulator_expectedMad' | translate }}</span>
          </label>
          <div class="d-flex align-items-center date-picker-wrapper" [class.has-danger]="isInvalidMad">
            <input
              id="expectedMad"
              type="text"
              class="form-control date-picker"
              formControlName="expectedMad"
              ngbDatepicker
              #date="ngbDatepicker"
              firstDayOfWeek="1"
              [value]="expectedMad ? (expectedMad | ngbDate) : ''"
              (dateSelect)="onExpectedMadSelect($event, 'select')"
              (input)="onExpectedMadSelect($event, 'input')"
              (navigate)="onMonthNavigate($event)"
              [startDate]="expectedMad ? expectedMad : ''" />
            <div class="date-toggle d-flex flex-column justify-content-center" (click)="date.toggle()">
              <img src="/assets/img/square-calendar.svg" alt="Expected Mad" />
            </div>
          </div>
        </div>

        @if (simulatorForm?.value?.projectType == TimelineCampaignTypes.PRODUCT_CAMPAIGN) {
          <div class="form-group">
            <label>
              <span class="icon-wrapper"><i class="fa fa-question" aria-hidden="true"></i></span>
              <span class="text">{{ 'timelineSimulator_productLaunchType' | translate }}</span>
            </label>
            <div class="select-wrapper">
              <div class="launch-type-dropdown" ngbDropdown>
                <div class="dropdown-label" role="button" ngbDropdownToggle>
                  {{ simulatorForm?.value?.productLaunchType }}
                </div>
                <div class="select-menu" ngbDropdownMenu>
                  @for (item of availableProductLaunchTypes; track item.value) {
                    <div ngbDropdownItem role="button" class="menu-item" (click)="switchProductLaunchType(item.value)">
                      {{ item.text }}
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>

          @if (availableComplexities.length > 0) {
            <div class="form-group">
              <label>
                <span class="icon-wrapper"><i class="fa fa-question" aria-hidden="true"></i></span>
                <span class="text">{{ 'timelineSimulator_productComplexity' | translate }}</span>
              </label>
              <div class="select-wrapper">
                <div class="complexity-dropdown" ngbDropdown>
                  <div class="dropdown-label" role="button" ngbDropdownToggle>
                    {{ simulatorForm?.value?.complexity }}
                  </div>
                  <div class="select-menu" ngbDropdownMenu>
                    @for (item of availableComplexities; track item.value) {
                      <div role="button" ngbDropdownItem class="menu-item" (click)="switchComplexity(item.value)">
                        {{ item.text }}
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }

          <div class="form-group">
            <label>
              <span class="icon-wrapper"><i class="fa fa-question" aria-hidden="true"></i></span>
              <span class="text">{{ 'CampaignType' | translate }}</span>
            </label>
            <div class="select-wrapper">
              <div class="campaign-type-dropdown" ngbDropdown>
                <div class="dropdown-label" role="button" ngbDropdownToggle>
                  {{ simulatorForm?.value?.campaignType }}
                </div>
                <div class="select-menu" ngbDropdownMenu>
                  @for (item of availableCampaignTypes; track item.value) {
                    <div role="button" ngbDropdownItem class="menu-item" (click)="switchCampaignType(item.value)">
                      {{ item.text }}
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        }

        @if (simulatorForm?.value?.projectType == TimelineCampaignTypes.HALLMARKS) {
          <div class="form-group">
            <label>
              <span class="icon-wrapper"><i class="fa fa-question" aria-hidden="true"></i></span>
              <span class="text">{{ 'timelineSimulator_hallmarksType' | translate }}</span>
            </label>
            <div class="select-wrapper">
              <div class="hallmarks-type-dropdown" ngbDropdown>
                <div class="dropdown-label" role="button" ngbDropdownToggle>
                  {{ HallmarksTypeTexts[simulatorForm?.value?.hallmarksType] }}
                </div>
                <div class="select-menu" ngbDropdownMenu>
                  @for (item of availableHallmarksTypes; track item.value) {
                    <div ngbDropdownItem role="button" class="menu-item" (click)="switchHallmarksType(item.value)">
                      {{ item.text }}
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label>
              <span class="icon-wrapper"><i class="fa fa-question" aria-hidden="true"></i></span>
              <span class="text">{{ 'collector' | translate }}</span>
            </label>
            <div class="select-wrapper">
              <div class="collector-dropdown" role="button" ngbDropdown>
                <div class="dropdown-label collector-dropdown-label" ngbDropdownToggle>
                  @if (simulatorForm?.value?.collectorType == CollectorTypes.INCLUDE_FOR_CHINA) {
                    <span>Yes:</span>
                    <span>Include for China</span>
                  }
                  @if (simulatorForm?.value?.collectorType == CollectorTypes.NOT_FOR_CHINA) {
                    <span>Yes:</span>
                    <span>Not for China</span>
                  }
                  @if (simulatorForm?.value?.collectorType == CollectorTypes.YES) {
                    <span>Yes</span>
                  }
                  @if (simulatorForm?.value?.collectorType == CollectorTypes.NO) {
                    <span>No</span>
                  }
                </div>
                <div class="select-menu" ngbDropdownMenu>
                  @if (availableCollectors.includes(CollectorTypes.INCLUDE_FOR_CHINA)) {
                    <div
                      class="menu-item collector-menu-item"
                      ngbDropdownItem
                      (click)="switchCollectorType(CollectorTypes.INCLUDE_FOR_CHINA)">
                      <span>Yes:</span>
                      <span>Include for China</span>
                    </div>
                  }
                  @if (availableCollectors.includes(CollectorTypes.NOT_FOR_CHINA)) {
                    <div
                      class="menu-item collector-menu-item"
                      ngbDropdownItem
                      (click)="switchCollectorType(CollectorTypes.NOT_FOR_CHINA)">
                      <span>Yes:</span>
                      <span>Not for China</span>
                    </div>
                  }
                  @if (availableCollectors.includes(CollectorTypes.YES)) {
                    <div
                      class="menu-item collector-menu-item"
                      ngbDropdownItem
                      (click)="switchCollectorType(CollectorTypes.YES)">
                      <span>Yes</span>
                    </div>
                  }
                  @if (availableCollectors.includes(CollectorTypes.NO)) {
                    <div
                      class="menu-item collector-menu-item"
                      ngbDropdownItem
                      (click)="switchCollectorType(CollectorTypes.NO)">
                      <span>No</span>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>

          @if (availableCollectorComplexities.length > 0) {
            <div class="form-group">
              <label>
                <span class="icon-wrapper"><i class="fa fa-question" aria-hidden="true"></i></span>
                <span class="text">{{ 'timelineSimulator_collectorComplexity' | translate }}</span>
              </label>
              <div class="select-wrapper">
                <div class="complexity-dropdown" ngbDropdown>
                  <div class="dropdown-label" role="button" ngbDropdownToggle>
                    {{ simulatorForm?.value?.collectorComplexity }}
                  </div>
                  <div class="select-menu" ngbDropdownMenu>
                    @for (item of availableCollectorComplexities; track item.value) {
                      <div
                        role="button"
                        ngbDropdownItem
                        class="menu-item"
                        (click)="switchCollectorComplexity(item.value)">
                        {{ item.text }}
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }

          <div class="form-group">
            <label>
              <span class="icon-wrapper"><i class="fa fa-question" aria-hidden="true"></i></span>
              <span class="text">{{ 'set' | translate }}</span>
            </label>
            <div class="select-wrapper">
              <div class="set-dropdown" role="button" ngbDropdown>
                <div class="dropdown-label set-dropdown-label" ngbDropdownToggle>
                  @if (simulatorForm?.value?.set == PosmValues.DMI_PRODUCED) {
                    <span>Yes:</span>
                    <span>DMI Produced</span>
                  }
                  @if (simulatorForm?.value?.set == PosmValues.LOCALLY_PRODUCED) {
                    <span>Yes:</span>
                    <span>Locally Produced</span>
                  }
                  @if (simulatorForm?.value?.set == PosmValues.NO) {
                    <span>No</span>
                  }
                </div>
                <div class="select-menu" ngbDropdownMenu>
                  @if (availableSets.includes(PosmValues.DMI_PRODUCED)) {
                    <div class="menu-item set-menu-item" ngbDropdownItem (click)="switchSet(PosmValues.DMI_PRODUCED)">
                      <span>Yes:</span>
                      <span>DMI Produced</span>
                    </div>
                  }
                  @if (availableSets.includes(PosmValues.LOCALLY_PRODUCED)) {
                    <div
                      class="menu-item set-menu-item"
                      ngbDropdownItem
                      (click)="switchSet(PosmValues.LOCALLY_PRODUCED)">
                      <span>Yes:</span>
                      <span>Locally Produced</span>
                    </div>
                  }
                  @if (availableSets.includes(PosmValues.NO)) {
                    <div class="menu-item set-menu-item" ngbDropdownItem (click)="switchSet(PosmValues.NO)">
                      <span>No</span>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        }

        @if (availablePosm.length > 0) {
          <div class="form-group">
            <label>
              <span class="icon-wrapper"><i class="fa fa-question" aria-hidden="true"></i></span>
              <span class="text">{{ 'timelineSimulator_posm' | translate }}</span>
            </label>
            <div class="select-wrapper">
              <div class="posm-dropdown" role="button" ngbDropdown>
                <div class="dropdown-label posm-dropdown-label" ngbDropdownToggle>
                  @if (simulatorForm?.value?.posm == PosmValues.DMI_PRODUCED) {
                    <span>Yes:</span>
                    <span>DMI Produced</span>
                  }
                  @if (simulatorForm?.value?.posm == PosmValues.LOCALLY_PRODUCED) {
                    <span>Yes:</span>
                    <span>Locally Produced</span>
                  }
                  @if (simulatorForm?.value?.posm == PosmValues.NO) {
                    <span>No</span>
                  }
                </div>
                <div class="select-menu" ngbDropdownMenu>
                  @if (availablePosm.includes(PosmValues.DMI_PRODUCED)) {
                    <div class="menu-item posm-menu-item" ngbDropdownItem (click)="switchPosm(PosmValues.DMI_PRODUCED)">
                      <span>Yes:</span>
                      <span>DMI Produced</span>
                    </div>
                  }

                  @if (availablePosm.includes(PosmValues.LOCALLY_PRODUCED)) {
                    <div
                      class="menu-item posm-menu-item"
                      ngbDropdownItem
                      (click)="switchPosm(PosmValues.LOCALLY_PRODUCED)">
                      <span>Yes:</span>
                      <span>Locally Produced</span>
                    </div>
                  }

                  @if (availablePosm.includes(PosmValues.NO)) {
                    <div class="menu-item posm-menu-item" ngbDropdownItem (click)="switchPosm(PosmValues.NO)">
                      <span>No</span>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </form>
  }
</div>
